/* Keep registration drafts in this form only; never store credentials. */
(function () {
  "use strict";
  function create(form, submit, minimumAge = () => 16) {
    const panels = [...form.querySelectorAll("[data-registration-step]")];
    const progress = form.querySelector("[data-registration-progress]");
    const next = form.querySelector("[data-registration-next]");
    const back = form.querySelector("[data-registration-back]");
    const finish = form.querySelector("button[type=submit]");
    const password = form.elements.password;
    const birthday = form.elements.birth_date;
    const confirmation = form.querySelector("#registration-password-confirm");
    const handle = form.elements.handle;
    const error = form.querySelector("[data-registration-error]");
    let step = 0, busy = false;
    form.noValidate = true;
    function keepFieldVisible(input) {
      if (!input?.matches("input") || !form.contains(input)) return;
      requestAnimationFrame(() => {
        const body = form.closest(".profile-body");
        if (!body || form.ownerDocument.activeElement !== input || !input.getClientRects().length) return;
        const field = input.getBoundingClientRect();
        const viewport = body.getBoundingClientRect();
        const footer = next.parentElement.getBoundingClientRect();
        const bottom = Math.min(viewport.bottom, footer.top) - 12;
        if (field.bottom > bottom) body.scrollTop += field.bottom - bottom;
        else if (field.top < viewport.top + 12) body.scrollTop += field.top - viewport.top - 12;
      });
    }
    form.addEventListener("focusin", event => keepFieldVisible(event.target));
    window.addEventListener("resize", () => keepFieldVisible(form.ownerDocument.activeElement));
    function normalizeHandle() {
      handle.value = handle.value.trim().replace(/^@/, "").toLowerCase();
      handle.setCustomValidity(handle.value && !/^[a-z0-9][a-z0-9_-]{2,29}$/.test(handle.value)
        ? "Use 3–30 letters, numbers, _ or -. Start with a letter or number; no spaces." : "");
    }
    handle.addEventListener("blur", normalizeHandle);
    function display(focus = false) {
      panels.forEach((panel, index) => { panel.hidden = index !== step; });
      progress.textContent = `Step ${step + 1} of ${panels.length}`;
      form.dataset.stage = String(step + 1);
      back.hidden = step === 0; next.hidden = step === panels.length - 1;
      finish.hidden = step !== panels.length - 1;
      back.disabled = next.disabled = busy;
      form.setAttribute("aria-busy", String(busy));
      if (focus) panels[step].querySelector("legend").focus();
    }
    function validate(index) {
      normalizeHandle();
      confirmation.setCustomValidity(confirmation.value === password.value ? "" : "Passwords do not match.");
      const today = new Date().toISOString().slice(0, 10);
      birthday.max = today;
      birthday.setCustomValidity("");
      if (birthday.value && birthday.checkValidity()) {
        const [year, month, day] = birthday.value.split("-").map(Number);
        const [nowYear, nowMonth, nowDay] = today.split("-").map(Number);
        const age = nowYear - year - Number(nowMonth < month || (nowMonth === month && nowDay < day));
        if (age < minimumAge()) birthday.setCustomValidity(`You must be at least ${minimumAge()} to join LOUDERR.`);
      }
      for (const input of panels[index].querySelectorAll("input")) {
        if (!input.checkValidity()) {
          step = index; display(); error.hidden = false; error.textContent = input.validationMessage;
          input.focus(); input.reportValidity(); return false;
        }
      }
      error.hidden = true; error.textContent = ""; return true;
    }
    function advance() {
      if (busy || !validate(step)) return;
      if (step < panels.length - 1) { step++; display(true); }
    }
    next.addEventListener("click", advance);
    back.addEventListener("click", () => {
      if (busy) return;
      error.hidden = true; error.textContent = ""; step = Math.max(0, step - 1); display(true);
    });
    form.addEventListener("input", () => {
      confirmation.setCustomValidity(""); birthday.setCustomValidity(""); handle.setCustomValidity(""); error.hidden = true; error.textContent = "";
    });
    form.addEventListener("reset", () => {
      step = 0; password.type = confirmation.type = "password";
      confirmation.setCustomValidity(""); birthday.setCustomValidity(""); handle.setCustomValidity(""); error.hidden = true; error.textContent = ""; display();
    });
    form.addEventListener("submit", async event => {
      event.preventDefault();
      if (busy) return;
      if (step < panels.length - 1) { advance(); return; }
      for (let index = 0; index < panels.length; index++) if (!validate(index)) return;
      busy = true; display();
      try { await submit(event); }
      finally { busy = false; display(); }
    });
    display();
    return { refresh: () => display() };
  }
  window.LouderrRegistration = { create };
})();
